export const TAG = "[CRM]";
export const MODULE_TITLE = "Customer Management";
export const SLICE = "crmSlice";
export const searchColumns = [
  "agent_name",
  "agent_number",
  "id",
  "is_completed",
  "lead_disposition",
  "email",
  "company",
  "lead_name",
  "lead_notes",
  "lead_phonenumbers",
  "lead_status",
  "followup_dt",
  "followup_notes",

  "action_taken",

  "customer_number",
  "customer_status",
  "agent && agent_number",
  "agent_status",
  "queue",
  "campaign_id",
  "call_duration_formatted",
  "action",
  "dtmf_extensions",
  "call_recording && call_duration_formatted",
  "voicemail_url",
  "disposition",
  "sub_disposition",
  "rule",
  "sms_text",
  "sms_type",
  "sr_number",
];

export const ANALYTICS = {
  MODULE_TITLE: "Customer Management",

  VIEW: [
    "Customer Management",
    "Click",
    "Customer Management Click",
    "Customer Management Click Left Nav",
  ],
  FILTER_LEAD: ["Customer Management", "Filters", "Lead Status", "<value>"],
  VIEW_MORE: [
    "Customer Management",
    "View More",
    "Customer Management View More",
    "",
  ],
  HEADER_SORTING_CREATED_ON: [
    "Customer Management",
    "Header Sorting",
    "Created On",
    "<value>",
    { asc: "Newest to Oldest", desc: "Oldest to Newest" },
  ],
  HEADER_SORTING_FOLLOW_UP: [
    "Customer Management",
    "Header Sorting",
    "Follow-Up",
    "<value>",
    { asc: "Newest to Oldest", desc: "Oldest to Newest" },
  ],
  HEADER_SORTING_LEAD_COMPANY: [
    "Customer Management",
    "Header Sorting",
    "Company",
    "<value>",
    { asc: "Newest to Oldest", desc: "Oldest to Newest" },
  ],
  EDIT: ["Customer Management", "Edit Customer Click", "Edit Customer", "Edit"],
  TICKER_EDIT_SAVE: [
    "Live Call Ticker (LCT)",
    "Add/Update Submit LCT",
    "Add/Update Customer Submit LCT",
    "Add/Update",
  ],
  EDIT_SAVE: [
    "Customer Management",
    "Edit Customer Click",
    "Edit Customer",
    "Save",
  ],
  EDIT_CANCEL: [
    "Customer Management",
    "Edit Customer Click",
    "Edit Customer",
    "Cancel",
  ],

  ADD_NOTE_CLICK: [
    "Customer Management",
    "Add Note/Disposition Click",
    "Add Note/Disposition",
    "Add Note/Disposition",
  ],
  ADD_NOTE_SAVE: [
    "Customer Management",
    "Add Note/Disposition Click",
    "Add Note/Disposition",
    "Save Note/Disposition",
  ],
  ADD_NOTE_CANCEL: [
    "Customer Management",
    "Add Note/Disposition Click",
    "Add Note/Disposition",
    "Cancel Note/Disposition",
  ],
  ADD_FOLLOWUP_CLICK: [
    "Customer Management",
    "Add Follow-Up Click",
    "Add Follow-Up",
    "Add Follow-Up",
  ],
  ADD_FOLLOWUP_SAVE: [
    "Customer Management",
    "Add Follow-Up Click",
    "Add Follow-Up",
    "Save Follow-Up",
  ],
  ADD_FOLLOWUP_CANCEL: [
    "Customer Management",
    "Add Follow-Up Click",
    "Add Follow-Up",
    "Cancel Follow-Up",
  ],
  SCHEDULE_FOLLOWUP_SAVE: [
    "Customer Management",
    "Schedule Follow-Up Click",
    "Schedule Follow-Up",
    "Save Follow-Up",
  ],
  SCHEDULE_FOLLOWUP_CANCEL: [
    "Customer Management",
    "Schedule Follow-Up Click",
    "Schedule Follow-Up",
    "Cancel Follow-Up",
  ],

  COPY_NUMBER_CLICK: [
    "Customer Management",
    "Copy Number Click",
    "Copy Number",
    "Copy Number",
  ],

  VIEW_ACTIVITY_CLICK: [
    "Customer Management",
    "View Activity Click",
    "View Customer Activity",
    "View",
  ],
  VIEW_CALL_HISTORY_CLICK: [
    "Customer Management",
    "View Call History Click",
    "View Call History",
    "View",
  ],
  VIEW_FOLLOWUP_CLICK: [
    "Customer Management",
    "View Follow-Up Click",
    "View Follow-Up",
    "View",
  ],
  RE_SCHEDULE_FOLLOWUP_SAVE: [
    "Customer Management",
    "Re-Schedule Follow-Up Click",
    "Re-Schedule Follow-Up",
    "Save",
  ],
  RE_SCHEDULE_FOLLOWUP_CANCEL: [
    "Customer Management",
    "Re-Schedule Follow-Up Click",
    "Re-Schedule Follow-Up",
    "Cancel",
  ],
  C2C: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Customer Screen",
  ],
  C2C_CRMHome: [
    "Click to Call",
    "C2C Widget Click",
    "C2C Widget Click",
    "Customer Management Home Screen",
  ],

  ADVANCE_FILTERS_CLICKED: "Advance Filters",
  SEARCH_USAGE: "Search",
  PAGINATION: "Paginated",
  PAGE_VIEWED: "Call Logs Page View",
};
